import type { Fields } from "@vuex-orm/core";
// eslint-disable-next-line import/no-cycle
import { Slide } from "./ActionHierarchy";
import type { ActionWithDuration, ActionWithText } from "./ActionTypes";

export class TextSlide extends Slide implements ActionWithDuration {
  // This is the name used as module name of the Vuex Store.
  public static entity = "textSlides";

  public static baseEntity = "actions";

  public static fields(): Fields {
    return {
      ...super.fields(),
      title: this.string(""),
      text: this.string(""),
      textColor: this.string("#ffffff"),
      backgroundColor: this.string("#000000"),
      horizontalAlignment: this.string("center"),
      callToAction: this.string(""),
      callToActionUrl: this.string(""),
    };
  }

  public declare title: string;

  public declare text: string;

  public declare textColor: string;

  public declare backgroundColor: string;

  public declare template: string;

  public declare horizontalAlignment: "left" | "center" | "right";

  public declare callToAction: string;

  public declare callToActionUrl: string;

  public static get humanName(): string {
    return "Text Slide";
  }

  public get estimatedReadingTime(): number {
    // we want to be pretty conservative here.
    const wordCount = `${this.title} ${this.text} ${this.callToAction}`.split(/\s+/).length;
    const wordsPerSecond = 3;
    return 2 + wordCount / wordsPerSecond;
  }

  public get duration(): number {
    return this.estimatedReadingTime;
  }

  public get description(): string {
    const parts: string[] = [];
    if (this.title) parts.push(this.title);
    if (this.text) parts.push(this.text);
    if (parts.length > 0) return parts.join("\n");
    if (this.callToAction) return this.callToAction;
    if (this.callToActionUrl) return this.callToActionUrl;
    return "";
  }
}
